export enum HsaLmnLookupEnvironment {
  Live = "live",
  Test = "test",
}
